import {computed, defineComponent, reactive, ref} from 'vue';
import {useUserStore} from "@/app/stores/user-store.ts";
import {useRouter} from "vue-router";
import {BillingDetails} from "@/app/billing-details/billing-details-routes.ts";
import type {BillingDetail} from "@/app/shared/components/aeg-billing-details/aeg-billing-details.ts";
import {storeToRefs} from "pinia";

export default defineComponent({
    name: 'AegBillingDetailsCard',
    props: {},
    setup() {
        const userStore = useUserStore();
        const router = useRouter();

        const {hasAddress, user, services} = storeToRefs(userStore);
        const actorInfo = ref(user.value.actorInfo);
        const errorLoading = ref(user.value.actorServiceDown);

        const loading = ref<boolean>(false);

        const goToBillingDetails = async () => {
            await router.push({
                name: BillingDetails.name,
            });
        }

        const actorState = reactive({
            vatNumber: user.value.actorInfo?.vatNumber ?? userStore.user.voOrgCode ?? '',
            companyName: userStore.user.isCitizen ? '' : (user.value.actorInfo?.name ?? user.value.organisationName) ?? '',
        });

        const loadBillingDetails = async () => {
            try {
                loading.value = true;
                await userStore.updateUserData();
                actorInfo.value = userStore.user.actorInfo;
            } finally {
                loading.value = false;
                errorLoading.value = user.value.actorServiceDown;
            }
        }

        const billingDetail = computed((): BillingDetail => {
            return {
                id: actorInfo.value?.id,
                companyName: actorState.companyName,
                vatNumber:  actorState.vatNumber,
                email: actorInfo.value?.email ?? '',
                street: actorInfo.value?.street ?? '',
                streetNumber: actorInfo.value?.streetNumber ?? '',
                bus: actorInfo.value?.bus ?? '',
                postCode: actorInfo.value?.postCode ?? '',
                city: actorInfo.value?.city ?? '',
                countryCode: actorInfo.value?.countryCode ?? '',
                emails: services.value.map(s => ({ service: s.service, email: s.email ?? '' }))
            } as BillingDetail;
        });

        return {
            loading,
            actorState,
            billingDetail,
            hasAddress,
            errorLoading,
            goToBillingDetails,
            loadBillingDetails
        }
    }
})
